<template>
    <div class="main-container">
        <!-- Navbar section -->
        <Navbar/>

        <!-- hero section -->
        <Hero/>

        <ContentSection>
            <template #header>{{ $t("sofie.section_1") }}</template>
            <template #main>
                <p>{{ $t("sofie.section_1_1") }}</p>
                <p>{{ $t("sofie.section_1_2") }}</p>
                <p>{{ $t("sofie.section_1_3") }}</p>
                <p>{{ $t("sofie.section_1_4") }}</p>
                <p>{{ $t("sofie.section_1_5") }}</p>
                <p>{{ $t("sofie.section_1_6") }}</p>
                <img class="content-image" alt="Figure 1" :src="require('../assets/img/trustami/sofie/1.png')" />
                <p>{{ $t("sofie.section_1_7") }}</p>
                <p>{{ $t("sofie.section_1_8") }}</p>
                <p>{{ $t("sofie.section_1_9") }}</p>
                <p>{{ $t("sofie.section_1_10") }}</p>
                <p>{{ $t("sofie.section_1_11") }}</p>
                <p>{{ $t("sofie.section_1_12") }}</p>
                <img class="content-image" alt="Figure 1" :src="require('../assets/img/trustami/sofie/2.png')" />
            </template>
        </ContentSection>

        <!-- footer section -->
        <FooterMain/>

    </div>
</template>

<script>
import Hero from '../comp_trustami/Research/Sofie/Hero';
import ContentSection from '../comp_trustami/Research/ContentSection';
import FooterMain from '../comp_trustami/FooterMain';
import Navbar from "../comp_trustami/NavbarSub";

export default {
    name: 'app',
    components: {
        Navbar,
        Hero,
        ContentSection,
        FooterMain,
    },

    metaInfo: {
        title: 'SOFIE - Trustami.AI Web Services',
        meta: [
            {
                name: 'description',
                content: 'Advanced Fake Shop and Fake Review Detection using Machine Learning.'
            }
        ],
        htmlAttrs: {
            lang: 'en',
            amp: true
        }
    }
}
</script>
